<template>
  <div>
    <div class="mb-5">
      <b-modal id="add-update-employee-modal" title="Departments Add/Update" size="lg" hide-footer>
        <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
          <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br/></span>
        </div>
        <div class="modal-content bg-white rounded">
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="name" class="col-form-label col-form-label-sm">Name <span class="custom-required">*</span></label>
              <input type="text" v-model="employee.name" v-validate="'required|max:255'" id="name" name="name" class="form-control form-control-sm" placeholder="Enter employee name"/>
              <div class="invalid-feedback">{{ errors.first('name') }}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="designation" class="col-form-label col-form-label-sm">Designation <span class="custom-required">*</span></label>
              <input type="text" v-model="employee.designation" v-validate="'required|max:255'" id="designation" name="designation" class="form-control form-control-sm" placeholder="Enter employee designation"/>
              <div class="invalid-feedback">{{ errors.first('designation') }}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="department_id" class="col-form-label col-form-label-sm">Department <span class="custom-required">*</span></label>
              <select v-model="employee.department_id" v-validate="'required'" id="department_id" name="department" class="form-control form-control-sm">
                <option selected disabled :value="''">Select department</option>
                <option v-for="(department, index) in departments" :key="index" :value="department.id">{{ department.department_name }}</option>
              </select>
              <div class="invalid-feedback">{{ errors.first('department') }}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="employee_id" class="col-form-label col-form-label-sm">Employee ID <span class="custom-required">*</span></label>
              <input type="text" v-model="employee.employee_id" v-validate="{ required: true, min: 2, max: 15 }" id="employee_id" name="employee id" class="form-control form-control-sm" placeholder="Enter employee id"/>
              <div class="invalid-feedback">{{ errors.first('employee id') }}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="phone_no" class="col-form-label col-form-label-sm">Phone No <span class="custom-required">*</span></label>
              <input type="text" v-model="employee.phone_no" v-validate="{ required: true, integer:true,  max: 11, min: 11, regex: /^[0-9]*$/ }"  id="phone_no" name="phone no" class="form-control form-control-sm" placeholder="Enter employee phone no"/>
              <div class="invalid-feedback">{{ errors.first('phone no') }}</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label for="status" class="col-form-label col-form-label-sm">Status <span class="custom-required">*</span></label>
              <select v-model="employee.status" v-validate="{ required: true }" id="status" name="status" class="form-control form-control-sm">
                <option selected disabled :value="''">Select a status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <div class="invalid-feedback">Status is required</div>
            </div>
          </div>
          <div class="form-row mt-3 mb-3">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <a-button type="primary" v-if="!this.btnEdit" class="text-center mr-2" :loading="loader"  @click.prevent="save">Add</a-button>
              <a-button type="primary" v-if="this.btnEdit" class="text-center mr-2" :loading="loader"  @click.prevent="update">Update</a-button>
              <a-button type="danger" class="text-center" @click="$bvModal.hide('add-update-employee-modal')">Cancel</a-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import $ from 'jquery'

export default {
  name: 'addUpdateEmployee',
  props: ['employee', 'btnEdit', 'show'],
  data() {
    return {
      departments: [],
      validation_errors: {},
      loader: false,
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    getCode() {
      apiClient.get('api/employee/codes')
        .then(response => {
          const data = response.data
          this.departments = data.departments
        })
        .catch(error => {
          console.log(error)
        })
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loader = true
          apiClient.post('api/employees', this.employee).then(response => {
            this.loader = false
            this.$notification.success({
              message: response.data.message,
            })
            $('#employee_list').DataTable().destroy()
            this.$emit('resetForm')
            this.$emit('getEmployees')
          }).catch(error => {
            this.loader = false
            this.validation_errors = error.response.data.errors
            this.show = true
            this.hide()
          })
        }
      })
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loader = true
          apiClient.put('api/employees/' + this.employee.id, this.employee)
            .then(response => {
              if (!response.data.error) {
                this.loader = false
                $('#employee_list').DataTable().destroy()
                this.$bvModal.hide('add-update-employee-modal')
                this.$emit('getEmployees')
                this.$notification.success({
                  message: response.data.message,
                })
              } else {
                this.loader = false
                this.$notification.error({
                  message: 'Update Failed',
                })
              }
            })
            .catch(error => {
              this.loader = false
              this.show = true
              this.validation_errors = error.response.data.errors
              this.hide()
            })
        }
      })
    },
    hide() {
      setTimeout(() => {
        this.show = false
      }, 5000)
    },
  },
}
</script>

<style>
.error{
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.borderColor{
  border: 1px solid red !important;
  border-radius:4px !important;
}
</style>
